import { PdfViewerDialog } from '@/components/shared/PdfViewerDialog';

// Looking at a generated invoice without saving a copy of it.
//
// Both surfaces that render InvoiceRowActions open this one: the /invoices
// workspace and the job Billing tab. It sits in the same FileViewerShell a job
// photo and a job document do, so "open the thing and look at it" is one window
// everywhere in the app.
//
// The iframe renders the browser's own PDF viewer off a blob: URL — see
// usePdfObjectUrl for why the bytes can't simply be a src.

/** Just enough of a row to name and fetch the invoice. */
export interface InvoicePdfViewerTarget {
  invoiceId: string;
  invoiceNumber: string;
}

export interface InvoicePdfViewerDialogProps {
  /** The invoice to show; null closes the dialog and fetches nothing. */
  invoice: InvoicePdfViewerTarget | null;
  onClose: () => void;
}

export function InvoicePdfViewerDialog({ invoice, onClose }: InvoicePdfViewerDialogProps) {
  return (
    <PdfViewerDialog
      path={invoice ? `/invoices/${invoice.invoiceId}/pdf` : null}
      title={invoice ? `${invoice.invoiceNumber}.pdf` : ''}
      downloadName={invoice ? `${invoice.invoiceNumber}.pdf` : ''}
      onClose={onClose}
    />
  );
}
